<template>
  <v-chip size="x-small" class="color-chip" variant="text">
    {{ questionnaireStatusToDisplayText(status) }}
  </v-chip>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  getQuestionnaireStatusColor,
  getQuestionnaireStatusTextColor,
  questionnaireStatusToDisplayText,
  type QuestionnaireStatus,
} from "@/models/questionnaireStatus";

const props = defineProps<{
  status: QuestionnaireStatus;
}>();

const statusColor = computed(() => getQuestionnaireStatusColor(props.status));
const textColor = computed(() => getQuestionnaireStatusTextColor(props.status));
</script>

<style scoped lang="scss">
.color-chip {
  color: v-bind(textColor);
  background-color: v-bind(statusColor);
}
</style>
